import config from '../config';
import { AuthServiceClientProtobuf } from '../proto/auth.twirp';
import { FetchRPC } from './client';
import { IntakeRequest, IntakeRequest_TestOption, VerificationRequest } from '../proto/auth';
import { User } from '../proto/user';

const authClient = new AuthServiceClientProtobuf(FetchRPC({
    baseUrl: config.apiUrl
}))

const RegistrationService = {
    register(user: User, password: string, testOption: IntakeRequest_TestOption, referrerCode: string | undefined): Promise<any> {
        const registrationRequest: IntakeRequest = {
            newUser: user,
            password,
            testOption,
            referralCode: referrerCode || ''
        }

        console.log(registrationRequest);

        return new Promise((resolve, reject) => {
            authClient.IntakeNewAccount(registrationRequest)
                .then(resp => {
                    if (resp && resp.error) {
                        reject(resp.error.message);
                    }

                    if (resp) {
                        resolve(resp);
                    }

                }, err => {
                    console.log(err);
                    reject('Internal Server Error');
                })
        })
    },

    verify(token: string): Promise<any> {
        const verificationRequest: VerificationRequest = {
            token
        }

        return new Promise((resolve, reject) => {
            authClient.VerifyEmail(verificationRequest)
                .then(resp => {
                    if (resp && resp.error) {
                        reject(resp.error.message);
                    }

                    if (resp) {
                        resolve(resp);
                    }

                }, err => {
                    reject('Internal Server Error');
                })
        })
    }
};

export default RegistrationService;